var _path, _path2, _path3, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMagicText(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7820_952",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 22,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6945 0.295166H1.02734V23.2369H22.6945V0.295166Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7820_952)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6945 0.295166H1.02734V23.2369H22.6945V0.295166Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_7820_952",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 21,
    height: 23
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3333 0H1.33331V22.5882H21.3333V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_7820_952)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.74724 6.93003H6.73677C6.5064 6.88422 5.38598 6.67803 5.08232 6.42603C4.74724 6.15113 4.63205 4.49023 4.63205 4.49023C4.63205 4.49023 4.5064 6.0595 4.1818 6.42603C3.89906 6.74676 2.82053 6.89567 2.54828 6.93003H2.52734H2.53781C2.76818 6.97586 3.8886 7.18203 4.19226 7.43403C4.52734 7.70894 4.64253 9.36984 4.64253 9.36984C4.64253 9.36984 4.76818 7.80057 5.09278 7.43403C5.3755 7.11331 6.45404 6.96439 6.72629 6.93003H6.74724Z",
    fill: "#0A0909"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.55321 13.2872H5.54274C5.31237 13.2414 4.19195 13.0352 3.88829 12.7832C3.55321 12.5083 3.43802 10.8474 3.43802 10.8474C3.43802 10.8474 3.31237 12.4167 2.98777 12.7832C2.70505 13.1039 1.62651 13.2528 1.35426 13.2872H1.33331H1.34378C1.57415 13.333 2.69457 13.5392 2.99823 13.7912C3.33331 14.0661 3.4485 15.7271 3.4485 15.7271C3.4485 15.7271 3.57415 14.1578 3.89875 13.7912C4.18149 13.4705 5.26002 13.3216 5.53226 13.2872H5.55321Z",
    fill: "#0A0909"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0665 10.8473C9.9304 10.8244 9.26024 10.6984 9.07176 10.5495C8.87281 10.3891 8.79952 9.39258 8.79952 9.39258C8.79952 9.39258 8.72621 10.3319 8.52726 10.5495C8.35972 10.7442 7.7105 10.8359 7.55344 10.8473H7.54297C7.67909 10.8702 8.34925 10.9962 8.53773 11.1451C8.73668 11.3055 8.80998 12.302 8.80998 12.302C8.80998 12.302 8.88328 11.3628 9.08224 11.1451C9.24977 10.9504 9.89898 10.8588 10.056 10.8473H10.0665Z",
    fill: "#0A0909"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3072 0H4.82023C4.27574 0 3.83594 0.481089 3.83594 1.07672V2.21071C3.83594 2.80635 4.27574 3.28744 4.82023 3.28744H11.0506V18.0065C11.0506 18.6021 11.4904 19.0947 12.0454 19.0947H13.082C13.6265 19.0947 14.0768 18.6136 14.0768 18.0065V3.29888H20.3072C20.8516 3.29888 21.3019 2.8178 21.3019 2.21071V1.07672C21.3019 0.481089 20.8621 0 20.3176 0H20.3072Z",
    fill: "#2820FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4745 22.5882H6.65253C6.21273 22.5882 5.86719 22.1987 5.86719 21.7292C5.86719 21.2595 6.22321 20.8701 6.65253 20.8701H18.4745C18.9143 20.8701 19.2599 21.2595 19.2599 21.7292C19.2599 22.1987 18.9039 22.5882 18.4745 22.5882Z",
    fill: "#2820FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.323 5.50964C21.1869 5.48674 20.5168 5.36074 20.3282 5.21183C20.1293 5.05147 20.056 4.05493 20.056 4.05493C20.056 4.05493 19.9826 4.99419 19.7837 5.21183C19.6162 5.40656 18.967 5.49819 18.81 5.50964H18.7994C18.9356 5.53256 19.6057 5.65855 19.7942 5.80747C19.9932 5.96783 20.0665 6.96437 20.0665 6.96437C20.0665 6.96437 20.1397 6.02511 20.3388 5.80747C20.5062 5.61274 21.1554 5.52111 21.3125 5.50964H21.323Z",
    fill: "#0A0909"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1291 7.91516C17.9929 7.89225 17.3228 7.76625 17.1343 7.61735C16.9353 7.45699 16.862 6.46045 16.862 6.46045C16.862 6.46045 16.7887 7.39971 16.5897 7.61735C16.4223 7.81207 15.7731 7.90371 15.616 7.91516H15.6055C15.7416 7.93807 16.4117 8.06407 16.6003 8.21297C16.7992 8.37333 16.8725 9.36988 16.8725 9.36988C16.8725 9.36988 16.9457 8.43061 17.1448 8.21297C17.3123 8.01825 17.9615 7.92661 18.1185 7.91516H18.1291Z",
    fill: "#0A0909"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagicText);
export default __webpack_public_path__ + "static/media/magic_text.6703df2dcffc7784c5cf7c475895387d.svg";
export { ForwardRef as ReactComponent };